export default __webpack_public_path__ + "static/media/team-mobile.61a14b01.jpg";